import React, { useState } from "react";
// import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/login.css";
import api from '../services/api';

function Register() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("user");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          await api.post("http://localhost:5001/api/register", { name, email, password, role });
        //   await axios.post("http://localhost:5001/api/register", { name, email, password, role });
          alert("Registration successful! You can now log in.");
          navigate("/login");
        } catch (err) {
          alert("Registration failed");
          console.error(err);
        }
    };

    return (
        <div className="login-container">
            <h2>Register</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    className="form-input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Full Name"
                    required
                />
                <input
                    type="email"
                    className="form-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    required
                />
                <input
                    type="password"
                    className="form-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                />

                <select
                    className="form-input"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                    required
                >
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                </select>
                <button type="submit" className="btn-primary">Register</button>
            </form>
        </div>
    );
}

export default Register;